<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Username"
          :type="{'is-danger': errors.has('username')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('username', 'required')
          }]">
          <b-input
            name="username"
            placeholder="username"
            icon="user"
            v-validate="'required'"
            v-model="model.username">
          </b-input>
        </b-field>
        <b-field label="Пароль" v-if="id">
          <b-input
            icon="key"
            placeholder="password"
            disabled
            v-model="model.password"></b-input>
        </b-field>
        <b-field label="Пароль" v-if="!id">
          <b-input
            type="password"
            icon="key"
            password-reveal
            placeholder="password"
            v-model="model.password"></b-input>
        </b-field>
        <b-field label="Повторите пароль" v-if="!id"
          :type="{'is-danger': errors.has('confirm-password')}"
          :message="[{
            'Пароль обязательное поле для заполнения' : errors.firstByRule('confirm-password', 'required'),
            'Введенные пароль не совпадают' : errors.firstByRule('confirm-password', 'is')
          }]">
          <b-input placeholder="Повторите пароль"
            type="password"
            icon="key"
            name="confirm-password"
            password-reveal
            v-model="confirmPassword"
            v-validate="{ required: true, is: model.password }">
          </b-input>
        </b-field>
        <b-field
          label="Электронной почта"
          :type="{'is-danger': errors.has('email')}"
          :message="[{
            'Адрес электронной почты обязательное поле для заполнения' : errors.firstByRule('email', 'required')
          }]">
            <b-input
              name="email"
              placeholder="Email"
              type="email"
              icon="at"
              v-validate="'required'"
              v-model="model.email">
            </b-input>
        </b-field>
        <b-field label="Роль">
          <b-select placeholder="Выбирете роль" expanded v-model="model.role_id">
            <option
              v-for="option in roles"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-select placeholder="Установите состояние" expanded v-model="model.is_active">
            <option
              v-for="option in states"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Уведомления">
          <b-select placeholder="Установите уведомления" expanded v-model="model.notify">
            <option
              v-for="option in notifies"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'UserForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    const roles = []
    const states = [
      {
        id: true,
        name: "Активный пользователь"
      },
      {
        id: false,
        name: "Не активный пользователь"
      }
    ]
    const notifies = [
      {
        id: true,
        name: "Уведомления включены"
      },
      {
        id: false,
        name: "Уведомления выключены"
      }
    ]
    return {
      roles: roles,
      states: states,
      notifies: notifies,
      confirmPassword: '',
      model: {
        id: undefined,
        email: '',
        password: '',
        role_id: null
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this
    this.$store.dispatch('getRoles')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.roles.push(item)
        })
      })
      .catch(error => {
        this.roles = []
      })

    if ($this.id){
      this.$store.dispatch('getUser', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
        })
        .catch(error => {
          this.model = this.purge_model
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateUser', $this.model)
      }
      else{
        $this.$store.dispatch('createUser', $this.model)
      }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>